import baseAPI from "@/api/base";
import { UpsertBusinessProfile } from "@/dtos/BusinessProfile.dto";
import {
  GET_BUSINESS_PROFILE_URL,
  SUBMIT_BUSINESS_PROFILE_URL,
  UPDATE_BUSINESS_PROFILE_URL,
} from "@/utils/urls";
import { AxiosResponse } from "axios";

class BusinessProfileService {
  static getBusinessProfile = async (): Promise<AxiosResponse> => {
    const response: AxiosResponse = await baseAPI.get(GET_BUSINESS_PROFILE_URL);
    return response;
  };

  static upsertBusinessProfile = async (
    upsertBusinessProfile: UpsertBusinessProfile
  ): Promise<AxiosResponse> => {
    const response: AxiosResponse = await baseAPI.post(UPDATE_BUSINESS_PROFILE_URL, {
      ...upsertBusinessProfile,
    });
    return response;
  };

  static submitBusinessProfile = async (): Promise<AxiosResponse> => {
    const response: AxiosResponse = await baseAPI.post(SUBMIT_BUSINESS_PROFILE_URL);
    return response;
  };
}

export default BusinessProfileService;
